import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IntiGoAuthGuardService } from './authentification/auth-guard-intiGoTeam.service';
import { ClientAuthGuardService } from './authentification/auth-guard-client.service';
import { MyRouterGuardService } from './authentification/routerGuard';
import { simpleAuthGuardService } from './authentification/simpleAuthGuard';
import { IntiGoAuthServices } from './authentification/IntiGoAuthServices.service';
const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'groups',
    loadChildren: () =>
      import('./pages/groups/groups.module').then((m) => m.GroupsModule),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'users',
    loadChildren: () =>
      import('./pages/users/users.module').then((m) => m.UsersModule),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'drivers',
    loadChildren: () =>
      import('./pages/drivers/drivers.module').then((m) => m.DriversModule),
  },
  {
    path: 'finance/manageBusiness',
    loadChildren: () =>
      import('./pages/admin-manage-business/admin-manage-business.module').then(
        (m) => m.AdminManageBusinessModule
      ),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'params',
    loadChildren: () =>
      import('./pages/params/params.module').then((m) => m.ParamsModule),
    canActivate: [IntiGoAuthGuardService],
  },
  // {
  //   path: 'permissions',
  //   loadChildren: () =>
  //     import('./pages/permission/permission.module').then((m) => m.PermissionModule),
  //   canActivate: [IntiGoAuthGuardService],
  // },

  {
    path: 'support',
    loadChildren: () =>
      import('./pages/support/main-support.module').then(
        (m) => m.SupportModule
      ),
    canActivate: [simpleAuthGuardService],
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [simpleAuthGuardService],
  },
  {
    path: 'manageConciergerie',
    loadChildren: () =>
      import('./pages/manage-conciergerie/manage-conciergerie.module').then(
        (m) => m.ManageConciergerieModule
      ),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'finance',
    loadChildren: () =>
      import('./pages/finance/finance.module').then((m) => m.FinanceModule),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'mobileApp',
    loadChildren: () =>
      import('./pages/app-versionning/app-versionning.module').then(
        (m) => m.AppVersionningModule
      ),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'manageConciergerie',
    loadChildren: () =>
      import('./pages/manage-conciergerie/manage-conciergerie.module').then(
        (m) => m.ManageConciergerieModule
      ),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'pointRelais',
    loadChildren: () =>
      import('./pages/point-relais/point-relais.module').then(
        (m) => m.PointRelaisModule
      ),
  },

  {
    path: 'payment',
    loadChildren: () =>
      import('./pages/payment/payment.module').then((m) => m.PaymentModule),
  },
  {
    path: 'driverPosition',
    loadChildren: () =>
      import('./pages/driver-position/driver-position.module').then(
        (m) => m.DriverPositionModule
      ),
  },
  {
    path: 'notifs',
    loadChildren: () =>
      import('./pages/list-notifications/list-notifications.module').then(
        (m) => m.ListNotificationsModule
      ),
    canActivate: [simpleAuthGuardService],
  },
  {
    path: 'manageDelivery',
    loadChildren: () =>
      import(
        './pages/manage-delivery-request/manage-delivery-request.module'
      ).then((m) => m.ManageDeliveryRequestModule),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'pickups',
    loadChildren: () =>
      import('./pages/pickups/pickups.module')
        .then((m) => m.PickupsModule)
        .catch((err) => console.log(err)),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'livraison',
    loadChildren: () =>
      import('./pages/livraison/livraison.module').then(
        (m) => m.LivraisonModule
      ),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'partner',
    loadChildren: () =>
      import(
        './pages/partner-dashboard-for-admin/partner-dashboard-for-admin.module'
      ).then((m) => m.PartnerDashboardForAdminModule),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'packages',
    loadChildren: () =>
      import('./pages/packages/packages.module').then((m) => m.PackagesModule),
    canActivate: [IntiGoAuthServices],
    data: { services: ['A-200'] },
  },
  {
    path: 'unsuccessfulDelivery',
    loadChildren: () =>
      import(
        './pages/manage-unsuccessful-deliveries/manage-unsuccessful-deliveries.module'
      ).then((m) => m.ManageUnsuccessfulDeliveriesModule),
    canActivate: [IntiGoAuthGuardService],
  },
  /*
    {
      path: 'noaddresses',
      loadChildren: () =>
        import('./pages/manage-noaddresses-deliveries/manage-noaddresses-deliveries.module').then((m) => m.ManageNoaddressesDeliveriesModule),
      canActivate: [IntiGoAuthGuardService],
    },
  */
  {
    path: 'updatepickuplocation',
    loadChildren: () =>
      import('./pages/update-pickup-address/update-pickup-address.module').then(
        (m) => m.MainPickUpAddressUpdateModule
      ),
  },
  {
    path: 'updatedropofflocation',
    loadChildren: () =>
      import(
        './pages/update-dropoff-address/update-dropoff-address.module'
      ).then((m) => m.MainDropOffAddressUpdateModule),
  },

  {
    path: 'packagingSlip',
    loadChildren: () =>
      import('./pages/packaging-slip/packaging-slip.module').then(
        (m) => m.PackagingSlipModule
      ),
    canActivate: [IntiGoAuthGuardService],
  },

  {
    path: 'dashboard',
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [simpleAuthGuardService],
  },
  {
    path: 'blackList',
    loadChildren: () =>
      import('./pages/black-list/black-list.module').then(
        (m) => m.BlackListModule
      ),
    canActivate: [simpleAuthGuardService],
  },
  {
    path: 'zone-exeptions',
    loadChildren: () =>
      import('./pages/black-list-zones/black-list-zones.module').then(
        (m) => m.BlackListZonesModule
      ),
    canActivate: [simpleAuthGuardService],
  },
  {
    path: 'trackDelivery',
    loadChildren: () =>
      import('./pages/track-delivery/track-delivery.module').then(
        (m) => m.TrackDeliveryModule
      ),
  },
  {
    path: 'livraison/cleanData',
    loadChildren: () =>
      import('./pages/clean-data/clean-data.module').then(
        (m) => m.CleanDataModule
      ),
    canActivate: [IntiGoAuthGuardService],
  },

  {
    path: 'livraison/scanner',
    loadChildren: () =>
      import('./pages/scanner/scanner.module')
        .then((m) => m.ScannerModule)
        .catch((err) => console.log(err)),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'livraison/reporting',
    loadChildren: () =>
      import('./pages/reporting/reporting.module').then(
        (m) => m.ReportingModule
      ),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'livraison/centralTransfer',
    loadChildren: () =>
      import('./pages/central-transfer/central-transfer.module').then(
        (m) => m.CentralTransferModule
      ),
    canActivate: [IntiGoAuthGuardService],
  },
  {
    path: 'finance/requestPayment',
    loadChildren: () =>
      import('./pages/request-payment/request-payment.module').then(
        (m) => m.RequestPaymentModule
      ),
    canActivate: [simpleAuthGuardService],
  },

  {
    path: '',
    pathMatch: 'full',
    children: [],
    canActivate: [MyRouterGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
